import script from "./BaseInput.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseInput.vue?vue&type=script&setup=true&lang=js"

import "./BaseInput.vue?vue&type=style&index=0&id=2a8375a8&scoped=true&lang=scss"

import exportComponent from "/var/www/gift/data/www/giftxyz.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a8375a8"]])

export default __exports__